export type Logger = {
  info: (message: string) => void;
  warn: (message: string) => void;
  error: (message: string) => void;
};

export function createLogger(prefix: string): Logger {
  return {
    info: (message: string) => console.log(`[prism:${prefix}] ${message}`),
    warn: (message: string) => console.warn(`[prism:${prefix}] ${message}`),
    error: (message: string) => console.error(`[prism:${prefix}] ${message}`),
  };
}
